import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { MattressFeelBlock as MattressFeelBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: MattressFeelBlockValue }>;

const getImageAlt = (image: IProps["value"]["image"]): string => {
    if (!image) {
        return "";
    }
    return image.default_alt_text || image.title;
};

export const MattressFeelBlock = (props: IProps): React.JSX.Element => {
    return (
        <section
            className={classNames(
                styles.mattressFeelBlock,
                props.value.extra_classes === "chill-bundle"
                    ? styles.mattressFeelBlockChillBundle
                    : null,
                getGlobalSpacingClasses(props.value.spacing),
            )}
        >
            <div className="main-container">
                <div
                    className={concatClassNames([
                        styles.mattressFeelBlockTitle,
                        "mattress-feel-block__title",
                    ])}
                    dangerouslySetInnerHTML={{
                        __html: props.value.title ?? "",
                    }}
                ></div>
                <div
                    className={concatClassNames([
                        styles.mattressFeelBlockCopy,
                        "mattress-feel-block__copy",
                    ])}
                    dangerouslySetInnerHTML={{
                        __html: props.value.subtitle ?? "",
                    }}
                ></div>

                <div className={styles.mattressFeelBlockImage}>
                    {props.value.image ? (
                        <img
                            src={props.value.image.url}
                            alt={getImageAlt(props.value.image)}
                            className={concatClassNames([
                                styles.imageDesktop,
                                "responsive",
                            ])}
                            width={props.value.image.width}
                            height={props.value.image.height}
                            loading="lazy"
                            decoding="async"
                        />
                    ) : null}
                    {props.value.image_mobile ? (
                        <img
                            src={props.value.image_mobile.url}
                            alt={getImageAlt(props.value.image_mobile)}
                            className={concatClassNames([
                                styles.imageMobile,
                                "responsive",
                            ])}
                            width={props.value.image_mobile.width}
                            height={props.value.image_mobile.height}
                            loading="lazy"
                            decoding="async"
                        />
                    ) : null}
                </div>
            </div>
        </section>
    );
};
